import React, { useMemo } from 'react';
import AuthService from './authservice';

export const AuthContext = React.createContext<AuthService | null>(null);

export const AuthConsumer = AuthContext.Consumer;

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const authService = useMemo(() => new AuthService(), []);

  return (
    <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>
  );
}
